export const promptMeta = {
  id: 'AD-FOOTER-REDESIGN-2025-11-10',
  title: 'Accessible, responsive footer (no newsletter)',
  timestamp: '2025-11-10',
  'AD-FOOTER-REDESIGN-2025-11-10': {
    summary: 'Redesigned footer with accessible mobile accordions, WCAG-AA contrast, brand blue #0000FF accents',
    category: 'ui',
  },
  'P20251010-ADMIN-USERS-TS-FIX-ALIGN-01': {
    summary: 'Fixed TypeScript errors and aligned magic link generation with Supabase Admin API v2',
    category: 'admin',
  },
  'P20251010-ADMIN-USERS-CONSOLIDATE-NODE-01': {
    summary:
      'Consolidated admin users API into single Node.js handler for Vercel Hobby compatibility',
    category: 'admin',
  },
  'P20251010-ADMIN-USERS-COMPLETE-FIX-06': {
    summary: 'Make /manage/users fully functional with Supabase Auth Admin API',
    category: 'admin',
  },
  'P20251010-ADMIN-USERS-NODE-FIX-03': {
    summary: 'Admin users tools migrated to Node.js Vercel routes',
    category: 'admin',
  },
  'P20251010-ADMIN-SEED-MAGIC-FIX-01': {
    summary:
      'Repair /api/manage/seed-user and /api/manage/magic-link (Supabase Admin), with diagnostics & self-test',
    category: 'admin',
  },
};

export const promptMirror = {
  id: 'AD-FOOTER-REDESIGN-2025-11-10',
  title: 'Accessible, responsive footer (no newsletter)',
};
